export default __webpack_public_path__ + "static/media/dollar.c54f83d6.png";